/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Appbrand1Inputs */

const en_appbrand1 = /** @type {(inputs: Appbrand1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ClaimPack`)
};

const pt_appbrand1 = /** @type {(inputs: Appbrand1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ClaimPack`)
};

/**
* | output |
* | --- |
* | "ClaimPack" |
*
* @param {Appbrand1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const appbrand1 = /** @type {((inputs?: Appbrand1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Appbrand1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_appbrand1(inputs)
	return pt_appbrand1(inputs)
});
export { appbrand1 as "appBrand" }